module.exports = __webpack_public_path__ + "static/media/4.9c637507.jpg";